import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

// Packages
import { Alert, Col, Flex, Row, Spin, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components
import { FileInfoCard } from '../../wizard/WizardFileInfoView';
import LoadFileReview from './LoadFileReview';
import LoadFileReviewError from './LoadFileReviewError';
import LoadRouteInfo from './LoadRouteInfo';
import FileValidationCard from '../../utils/FileValidationCard';
import LoadFileMovements from './LoadFileMovements';
import LoadFileDiscards from './LoadFileDiscards';

// Actions
import { check_file, set_selected_node, get_file_movements } from '../../../redux/actions/selfActions';

// Utils
import isEmpty from '../../../utils/isEmpty';

const LoadFileInfo = (props) => {
	const { messageApi } = props;

	const { t } = useTranslation();

	const { file_id } = useParams();

	const dispatch = useDispatch();

	const { file_check_loading, file_check, self_errors, selected_node } = useSelector(state => state.self);

	const [openModal, setOpenModal] = useState(false);
	const [historyId, setHistoryId] = useState('');

	useEffect(() => {
		dispatch(check_file(true, file_id));
	}, []);
	
	useEffect(() => {
		if (!isEmpty(selected_node)) {
			setOpenModal(true);
		}
	}, [selected_node]);	

	useEffect(() => {
		const interval = setInterval(() => {
			if (self_errors.hasOwnProperty('check_file')) {
				dispatch(check_file(false, file_id));
			}
			else {
				clearInterval(interval);
			}
		}, 1000 * 10);
	
		// Clean interval
		return () => clearInterval(interval);
	}, [self_errors]);

	const onCancel = () => {
		setOpenModal(false);
		dispatch(set_selected_node({}));
	}

	return (
		<Row justify='center'>
			<Col span={24}>
				<LoadRouteInfo openModal={openModal} node={selected_node} onCancel={onCancel} />

				<Typography.Title className='text-center' level={2}>{t('loadStatusDetails.title')}</Typography.Title>

				<FileInfoCard messageApi={messageApi} />

				{file_check_loading 
					?	<Flex justify='center' style={{ marginTop: '1.5rem' }}>
							<Spin size='large'/>
						</Flex>
					:	self_errors.hasOwnProperty('check_file')
						?	<Row justify='center'>
								<Alert
									style={{ marginTop: '1.5rem', width: 1000 }}
									message={t('loadStatusDetails.check.alert.msg')}
									description={t('loadStatusDetails.check.alert.desc')}
									type='info'
									showIcon
								/>
							</Row>
						:	!isEmpty(file_check)
							?	<>
									{/* Validation Card */}
									{file_check?.file?.status?.value === 2 && (
										<FileValidationCard />
									)}
									{file_check.data !== null && file_check.error === null && [3, 4, 5].includes(file_check?.file?.status?.value) && (
										// Check if hierarchy is present, if so, use new function, if not, render the old component
										file_check?.file?.hierarchy
										?	<LoadFileReview
												historyId={historyId}
												setHistoryId={setHistoryId}
												treeData={file_check?.data}
											/>
										:	<LoadFileReview
												historyId={historyId}
												setHistoryId={setHistoryId}
												treeData={file_check?.data?.regions}
											/>
									)}
									{file_check.data === null && file_check.error !== null &&
										<LoadFileReviewError
											error={file_check.error}
										/>
									}
									{/* Show movements summary after the review */}
									{file_check.data !== null && file_check.error === null &&
										<>
										<LoadFileMovements 
											historyId={historyId}
											getFileMovements={get_file_movements}
										/>
											<LoadFileDiscards
												historyId={historyId}
											/>
										</>
									}
								</>
							:	null
				}
			</Col>
		</Row>
	)
}

LoadFileInfo.propTypes = {
	messageApi: PropTypes.object.isRequired
}

export default LoadFileInfo;
